export const shared = {
  warning: "Warning",
  error: "Error",
  info: "Info",
  help: "Help",
  home: "Home",
};
